import {
  chakraComponents,
  DropdownIndicatorProps,
  GroupBase,
} from 'chakra-react-select';
import { ReactComponent as ChevronIcon } from 'resources/images/chevron-down.svg';
import { DetailedHTMLPropsWithTestId } from '../types';

export const DropdownIndicator = <Option extends {}>(
  props: DropdownIndicatorProps<Option, false, GroupBase<Option>>
) => {
  const { selectProps, hasValue, isFocused } = props;
  const { inputValue, isClearable, menuIsOpen, setOpen } = selectProps;
  const shouldRenderChevron = !(
    (inputValue || (hasValue && isClearable)) &&
    menuIsOpen
  );

  const handleClick = () => {
    if (isFocused) {
      setOpen(!menuIsOpen);
    }
  };

  return shouldRenderChevron ? (
    <chakraComponents.DropdownIndicator
      {...props}
      innerProps={
        {
          'data-testid': 'dropdown-indicator',
          onMouseDown: handleClick,
          onTouchEnd: handleClick,
        } as DetailedHTMLPropsWithTestId
      }
    >
      <ChevronIcon width={20} height={20} fill="var(--chakra-colors-M-60)" />
    </chakraComponents.DropdownIndicator>
  ) : null;
};
